import { Injectable } from '@angular/core';
import { AuthService } from '../login/auth.service';
import { InactivityService } from './inactivity.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthInactivityService {

  constructor(
    private authService: AuthService,
    private inactivityService: InactivityService,
    private router: Router
  ) {
    // Configurar el callback del servicio de inactividad
    this.inactivityService.setLogoutCallback(() => {
      this.handleInactivityLogout();
    });
  }

  /**
   * Iniciar sesión y configurar timer de inactividad
   */
  async login(credentials: {email: string, password: string}) {
    try {
      const response = await this.authService.login(credentials);

      // Si el login es exitoso, iniciar el timer de inactividad
      if (response['result']['token']) {
        this.inactivityService.startInactivityTimer();
      }

      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Cerrar sesión y detener timer de inactividad
   */
  logout() {
    // Detener timer de inactividad
    this.inactivityService.stopInactivityTimer();

    // Cerrar sesión
    this.authService.logout();
  }

  /**
   * Manejar logout por inactividad
   */
  private handleInactivityLogout() {
    // Cerrar sesión sin mostrar notificaciones
    this.authService.logout();

    // Redirigir al login
    this.router.navigate(['/login']);
  }

  /**
   * Verificar si el usuario está autenticado
   */
  isLoggedIn(): boolean {
    return this.authService.loggedIn();
  }

  /**
   * Reiniciar timer de inactividad (útil para navegación)
   */
  restartInactivityTimer(): void {
    if (this.isLoggedIn()) {
      this.inactivityService.startInactivityTimer();
    }
  }

  /**
   * Obtener configuración del servicio de inactividad
   */
  getInactivityConfig() {
    return this.inactivityService.getConfig();
  }

  /**
   * Configurar timeout de inactividad
   */
  setInactivityTimeout(minutes: number): void {
    this.inactivityService.setInactivityTimeout(minutes);
  }
}
